const initState = {
  bills: [],
  bill: {},
  totalCounts: 0,
  toast: null,
  isProcessing: false,
};

let failed; 
let success;
let messages;
let paymentStatus;

export const billReducer = (state = initState, action) => {
  switch (action.type) {
  case 'RESET_BILL_STATE':
    return { 
      ...initState
    };
  case 'RESET_TOAST_STATE':
    return {
      ...state,
      toast: null, 
      isProcessing: false,
    };
  case 'PROCESSING_BILL':
    return {
      ...state,
      toast: { type: 'LOADING', message: 'Please wait ...'},
      isProcessing: true,
    };

  case 'FETCH_BILLS':
    return {
      ...state,
      bills: action.payload && action.payload.data,
      totalCounts: action.payload && action.payload.totalCounts,
      toast: {type: 'SUCCESS'},
      isProcessing: false,
    };
  case 'ADD_BILL':
    return {
      ...state,      
      bills: [...state.bills, action.payload],
      toast: { type: 'SUCCESS', message: 'Bill saved successfully.'},
      isProcessing: false,
    };     
  case 'UPDATE_BILL':
  case 'SEARCHED_BILL':
    return {
      ...state,      
      bills: [...state.bills.filter(item => item.id !== action.payload.id), Object.assign({}, action.payload)], 
      toast: { type: 'SUCCESS', message: 'Bill updated successfully.' },
      isProcessing: false,
    };
  case 'BILL_PAYMENT_SUCCESS':
  case 'UNPAY_DRIVER':
    failed = [];  
    success = [];
    messages = [];    
    Object.entries(action.payload).forEach(entry => {  
      const id = Number(entry[0]);
      const msg = entry[1];
      msg.includes('ERROR') ? failed.push(id) : success.push(id);
      messages.push(`Bill ${id} ${msg}`);
    });
    // if(action.type === 'BILL_PAYMENT_SUCCESS') {
    //   paymentStatus = 'PAID';
    // } else {
    //   paymentStatus = 'UNPAID';
    // }    
    return {
      ...state,      
      // bills: [...state.bills.map(bill => success.includes(bill.id) ? {...bill, status: paymentStatus} : {...bill})],
      toast: { type: 'SUCCESS', action: action.type, message: messages},
      isProcessing: false,
    };    
  case 'BILL_ERROR':
    return {
      ...state,
      isProcessing: false,
      toast: { type: 'ERROR', message: action.payload},
    };
  default:
    return state;
  }
};
